<template>
  <div class="aia-page">
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/product">产品中心</router-link>
      <span class="separator">/</span>
      <span class="current">AI智能体（分析&治理）平台</span>
    </nav>

    <!-- 英雄区（产品Banner） -->
    <section class="aia-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <h1 class="aia-h1">AI智能体（分析&amp;治理）平台<br><span style="color: var(--aia-accent-blue);">AI Agent for Analytics &amp; Governance</span></h1>
        <p class="aia-subhead">多智能体协同 · 自主分析决策 · 自动治理优化，构建"数据分析智能体 + 数据治理智能体 + 协同调度中枢"一体化AI平台，实现数据自动分析、自动治理、风险自动识别与决策支持。</p>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <a href="#" class="aia-btn aia-btn-primary" @click.prevent="openModal">预约演示 <i class="fa-regular fa-calendar-check" style="margin-left: 8px;"></i></a>
          <a href="#" class="aia-btn aia-btn-outline" @click.prevent="downloadBrochure">下载产品手册 <i class="fa-regular fa-file-pdf" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键词云（SEO强化） -->
      <div class="aia-keyword-cloud">
        <h2 class="aia-keyword-tag highlight">AI智能体</h2>
        <h2 class="aia-keyword-tag">多智能体协同</h2>
        <h2 class="aia-keyword-tag">数据分析智能体</h2>
        <h2 class="aia-keyword-tag">数据治理智能体</h2>
        <h2 class="aia-keyword-tag">AI Agent</h2>
        <h2 class="aia-keyword-tag">企业AI平台</h2>
        <h2 class="aia-keyword-tag">智能决策系统</h2>
        <h2 class="aia-keyword-tag">数据治理自动化</h2>
        <h2 class="aia-keyword-tag">自然语言查询</h2>
        <h2 class="aia-keyword-tag">自动报告生成</h2>
      </div>
    </section>

    <!-- 行业背景与痛点 -->
    <section class="aia-container">
      <h2 class="aia-h2"><i class="fa-regular fa-star"></i> 2026 AI趋势与企业痛点</h2>
      <div class="aia-card-grid-3">
        <div class="aia-feature-card">
          <h3 class="aia-h3">数据分析依赖人工</h3>
          <p>SQL依赖技术人员，分析周期长，洞察发现滞后，无法快速响应业务变化。</p>
        </div>
        <div class="aia-feature-card">
          <h3 class="aia-h3">数据治理缺乏智能化</h3>
          <p>数据质量问题发现滞后，标准维护成本高，修复流程无法自动闭环。</p>
        </div>
        <div class="aia-feature-card">
          <h3 class="aia-h3">分析与治理割裂</h3>
          <p>治理问题未触发分析，分析结果未反向优化数据质量，协同效率低。</p>
        </div>
      </div>
      <p style="margin-top: 20px; font-size: 1.1rem;">2026年AI从"对话式助手"升级为"任务型执行智能体"，多智能体协同成为企业智能化升级的核心方向。</p>
    </section>

    <!-- 产品定位 -->
    <section class="aia-container">
      <h2 class="aia-h2"><i class="fa-regular fa-star"></i> 产品定位</h2>
      <div class="aia-arch-card" style="background: #F5F5F5; color: white;">
        <h2 style="color: black; margin-bottom: 20px;">AI智能体平台</h2>
        <p style="font-size: 16px;">融合数据分析智能体、数据治理智能体、决策支持智能体与多智能体调度中枢，实现数据自动分析、自动治理、风险自动识别、决策自动生成，构建可进化的企业AI智能体平台。</p>
      </div>
    </section>

    <!-- 核心功能模块（六个卡片，带颜色标识） -->
    <section class="aia-container">
      <h2 class="aia-h2"><i class="fa-regular fa-star"></i> 六大核心智能体能力</h2>
      <div class="aia-card-grid-6">
        <!-- 模块1：数据分析智能体 -->
        <div class="aia-feature-card">
          <h3 class="aia-h3">数据分析智能体</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 自然语言转SQL</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 自动构建分析模型</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 异常趋势自动发现</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 自动生成图表与报告</li>
          </ul>
          <div style="margin-top: 16px;"><span class="aia-keyword-tag">AI分析</span><span class="aia-keyword-tag">自然语言查询</span></div>
        </div>

        <!-- 模块2：数据治理智能体 -->
        <div class="aia-feature-card">
          <h3 class="aia-h3">数据治理智能体</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 数据质量自动监测</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 主数据一致性校验</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 数据标准自动匹配</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 异常自动修复建议</li>
          </ul>
          <div style="margin-top: 16px;"><span class="aia-keyword-tag">数据质量</span><span class="aia-keyword-tag">自动治理</span></div>
        </div>

        <!-- 模块3：异常与风险识别智能体 -->
        <div class="aia-feature-card">
          <h3 class="aia-h3">异常与风险识别智能体</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 异常指标自动识别</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 风险趋势预测</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 自动生成风险提示</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 触发治理流程</li>
          </ul>
          <div style="margin-top: 16px;"><span class="aia-keyword-tag">风险预警</span><span class="aia-keyword-tag">异常检测</span></div>
        </div>

        <!-- 模块4：多智能体协同调度系统 -->
        <div class="aia-feature-card">
          <h3 class="aia-h3">多智能体协同调度系统</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 任务自动分解</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 智能体协同调用</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 执行流程可视化</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 冲突协调与权限控制</li>
          </ul>
          <div style="margin-top: 16px;"><span class="aia-keyword-tag">协同调度</span><span class="aia-keyword-tag">任务分解</span></div>
        </div>

        <!-- 模块5：自动报告与决策支持系统 -->
        <div class="aia-feature-card">
          <h3 class="aia-h3">自动报告与决策支持系统</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 自动生成经营分析报告</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 自动生成治理报告</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 风险评估报告</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 可解释决策依据</li>
          </ul>
          <div style="margin-top: 16px;"><span class="aia-keyword-tag">自动报告</span><span class="aia-keyword-tag">决策支持</span></div>
        </div>

        <!-- 模块6：智能体持续学习与优化系统 -->
        <div class="aia-feature-card">
          <h3 class="aia-h3">智能体持续学习与优化系统</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 历史案例自动记录</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 模型持续优化</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 强化学习优化决策路径</li>
            <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 用户偏好记忆</li>
          </ul>
          <div style="margin-top: 16px;"><span class="aia-keyword-tag">自学习</span><span class="aia-keyword-tag">持续优化</span></div>
        </div>
      </div>
    </section>

    <!-- 技术架构亮点 -->
    <section class="aia-container">
      <h2 class="aia-h2"><i class="fa-regular fa-star"></i> 技术架构亮点</h2>
      <div class="aia-arch-card">
        <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: center; justify-content: center; margin-bottom: 30px;">
          <span class="aia-compliance-badge">企业级数据中台</span>
          <span class="aia-compliance-badge">知识图谱</span>
          <span class="aia-compliance-badge">大语言模型</span>
          <span class="aia-compliance-badge">多智能体调度框架</span>
          <span class="aia-compliance-badge">微服务架构</span>
          <span class="aia-compliance-badge">可解释性推理链</span>
        </div>
        <div class="aia-arch-grid">
          <div class="aia-arch-item">
            <aia-h3>大模型语义引擎</aia-h3>
            <p>基于LLM的自然语言理解、SQL生成、异常解释与报告生成，支持多轮对话与上下文记忆。</p>
          </div>
          <div class="aia-arch-item">
            <aia-h3>多智能体协同框架</aia-h3>
            <p>任务分解、智能体调度、冲突协调、执行链路可视化，确保复杂任务高效完成。</p>
          </div>
          <div class="aia-arch-item">
            <aia-h3>可解释推理链</aia-h3>
            <p>输出决策依据与置信度，支持追溯分析过程，增强决策可信度。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 典型应用场景 -->
    <section class="aia-container">
      <h2 class="aia-h2"><i class="fa-regular fa-star"></i> 典型应用场景</h2>
      <div class="aia-card-grid-4">
        <div class="aia-feature-card">
          <h3 class="aia-h3">集团型企业</h3>
          <p>自动生成经营分析报告，自动发现利润异常原因，驱动治理智能体修复数据。</p>
        </div>
        <div class="aia-feature-card">
          <h3 class="aia-h3">金融机构</h3>
          <p>风险指标自动识别，客户行为异常检测，自动触发合规审查流程。</p>
        </div>
        <div class="aia-feature-card">
          <h3 class="aia-h3">政府与监管机构</h3>
          <p>数据质量自动监测，监管风险自动预警，生成监管报告。</p>
        </div>
        <div class="aia-feature-card">
          <h3 class="aia-h3">制造与能源企业</h3>
          <p>设备数据异常分析，供应链数据治理优化，预测性维护建议。</p>
        </div>
      </div>
    </section>

    <!-- 产品核心优势 -->
    <section class="aia-container">
      <h2 class="aia-h2"><i class="fa-regular fa-star"></i> 产品核心优势</h2>
      <div class="aia-card-grid-4">
        <div class="aia-feature-card">
          <aia-h3>分析与治理一体化</aia-h3>
          <p>分析驱动治理，治理反哺分析，形成数据闭环。</p>
        </div>
        <div class="aia-feature-card">
          <aia-h3>多智能体协同执行</aia-h3>
          <p>任务自动分解、自动执行、自动优化，高效完成复杂任务。</p>
        </div>
        <div class="aia-feature-card">
          <aia-h3>数据驱动智能决策</aia-h3>
          <p>从数据分析升级为自动决策支持，辅助管理层决策。</p>
        </div>
        <div class="aia-feature-card">
          <aia-h3>持续进化能力</aia-h3>
          <p>模型持续优化，智能体自我学习升级，适应业务变化。</p>
        </div>
      </div>
    </section>

    <!-- 项目成果与价值（数据指标） -->
    <section class="aia-container">
      <h2 class="aia-h2"><i class="fa-regular fa-star"></i> 关键成果与价值</h2>
      <div class="aia-stat-grid">
        <div class="aia-stat-card">
          <div class="aia-stat-number">70%</div>
          <p>分析效率提升</p>
        </div>
        <div class="aia-stat-card">
          <div class="aia-stat-number">60%</div>
          <p>治理自动化率</p>
        </div>
        <div class="aia-stat-card">
          <div class="aia-stat-number">实时</div>
          <p>风险监测</p>
        </div>
        <div class="aia-stat-card">
          <div class="aia-stat-number">持续</div>
          <p>自我优化</p>
        </div>
      </div>
      <div style="margin-top: 40px;">
        <ul style="list-style: none; display: flex; flex-wrap: wrap; gap: 30px; justify-content: center;">
          <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 自然语言查询，人人可用数据分析</li>
          <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 数据质量问题自动发现与修复</li>
          <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 风险预警提前3-6个月</li>
          <li class="aia-list-item"><i class="fa-regular fa-circle-check"></i> 报告生成时间从天级缩短到分钟级</li>
        </ul>
      </div>
    </section>

    <!-- 适用客户群体 -->
    <section class="aia-container">
      <h2 class="aia-h2"><i class="fa-regular fa-star"></i> 适用客户群体</h2>
      <div class="aia-client-tags">
        <span class="aia-client-tag">央企集团</span>
        <span class="aia-client-tag">地方国企</span>
        <span class="aia-client-tag">金融机构</span>
        <span class="aia-client-tag">政府单位</span>
        <span class="aia-client-tag">能源企业</span>
        <span class="aia-client-tag">制造企业</span>
        <span class="aia-client-tag">数据中台部门</span>
        <span class="aia-client-tag">IT部门</span>
      </div>
    </section>

    <!-- 常见问题 FAQ -->
    <section class="aia-container">
      <h2 class="aia-h2"><i class="fa-regular fa-star"></i> 常见问题</h2>
      <div class="aia-faq-list">
        <div class="aia-faq-item">
          <div class="aia-faq-question"><i class="fa-regular fa-message"></i> 多智能体如何协同工作？</div>
          <div class="aia-faq-answer">调度中枢将用户任务分解为子任务，分发给数据分析、治理、风险等智能体，各智能体并行执行，最后汇总结果输出，整个过程可视化可追溯。</div>
        </div>
        <div class="aia-faq-item">
          <div class="aia-faq-question"><i class="fa-regular fa-message"></i> 智能体能否适配企业特有业务？</div>
          <div class="aia-faq-answer">支持通过企业知识库、历史案例微调模型，智能体可学习企业特有术语、规则和分析逻辑，实现个性化适配。</div>
        </div>
        <div class="aia-faq-item">
          <div class="aia-faq-question"><i class="fa-regular fa-message"></i> 如何保证数据安全与权限控制？</div>
          <div class="aia-faq-answer">平台内置细粒度权限体系，智能体执行任务时严格遵循数据权限，支持私有化部署，满足安全合规要求。</div>
        </div>
        <div class="aia-faq-item">
          <div class="aia-faq-question"><i class="fa-regular fa-message"></i> 是否需要大量训练数据？</div>
          <div class="aia-faq-answer">零样本即可启动通用分析，通过使用过程中的反馈与历史案例，智能体持续优化，无需预先准备大量标注数据。</div>
        </div>
        <div class="aia-faq-item">
          <div class="aia-faq-question"><i class="fa-regular fa-message"></i> 实施周期需要多久？</div>
          <div class="aia-faq-answer">一般2-3个月完成试点上线，包括数据接入、智能体配置、知识库构建和人员培训。</div>
        </div>
      </div>
    </section>

    <!-- 预约咨询 -->
    <section id="contact" class="section cta-section">
      <h2>预约咨询</h2>
      <div class="cta-inner">
        <h3 class="cta-heading">构建可信、统一的数据治理与 AI 治理体系</h3>
        <p class="cta-sub">当前已服务 100+ 央企国企，覆盖能源、电力、制造、金融等重点行业</p>
        <div class="cta-actions">
          <button class="cta-btn cta-btn--primary" @click="showModal = true">
            <i class="fas fa-calendar-check"></i>
            预约咨询
          </button>
          <button class="cta-btn cta-btn--outline" @click="showQrCode">
            <i class="fab fa-weixin"></i>
            扫码添加顾问
          </button>
        </div>
        <div class="cta-contact-row">
          <span><i class="fas fa-phone-alt"></i> 185-1017-6330</span>
          <span class="divider">|</span>
          <span><i class="fas fa-envelope"></i> pmo@gushandata.cn</span>
          <span class="divider">|</span>
          <span><i class="fas fa-clock"></i> 1小时内响应 · 严格保密</span>
        </div>
      </div>
    </section>

    <!-- 预约咨询弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showModal" @click.self="showModal = false">
      <div class="modal-container appointment-modal">
        <div class="modal-header">
          <div class="modal-header-icon"><i class="fas fa-calendar-check"></i></div>
          <div>
            <h3 class="modal-title">预约专家一对一咨询</h3>
            <p class="modal-subtitle">我们将在 1 小时内安排资深顾问与您联系</p>
          </div>
          <button class="modal-close-btn" @click="showModal = false"><i class="fas fa-times"></i></button>
        </div>
        <form class="appt-form" @submit.prevent="submitForm">
          <div class="form-row">
            <div class="form-group">
              <label>姓名 <span class="required">*</span></label>
              <input type="text" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label>联系电话 <span class="required">*</span></label>
              <input type="tel" placeholder="便于顾问联系您" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>公司名称</label>
              <input type="text" placeholder="您所在的公司" />
            </div>
            <div class="form-group">
              <label>职位</label>
              <input type="text" placeholder="您的职位/部门" />
            </div>
          </div>
          <div class="form-group">
            <label>咨询方向</label>
            <select>
              <option value="">-- 请选择咨询方向 --</option>
              <option>AI 智能体平台咨询</option>
              <option>多智能体协同架构设计</option>
              <option>大模型私有化部署</option>
              <option>AI 治理与合规</option>
              <option>行业场景落地方案</option>
              <option>其他（请备注）</option>
            </select>
          </div>
          <div class="form-group">
            <label>补充说明</label>
            <textarea rows="2" placeholder="简述您的业务场景或待解决的问题（可选）"></textarea>
          </div>
          <button type="submit" class="form-submit-btn">
            <i class="fas fa-paper-plane"></i> 提交预约
          </button>
          <p class="form-privacy"><i class="fas fa-lock"></i> 您的信息将严格保密，仅用于本次咨询联系</p>
        </form>
      </div>
    </div>
    </transition>

    <!-- 扫码添加顾问弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showQrModal" @click.self="showQrModal = false">
      <div class="modal-container qr-modal">
        <div class="modal-header">
          <div class="modal-header-icon qr-header-icon"><i class="fab fa-weixin"></i></div>
          <div>
            <h3 class="modal-title">扫码添加顾问</h3>
            <p class="modal-subtitle">加微信，获取一对一专属服务</p>
          </div>
          <button class="modal-close-btn" @click="showQrModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="qr-grid">
          <div class="qr-card" v-for="(img, idx) in qrImages" :key="idx">
            <div class="qr-img-wrap">
              <img v-if="img" :src="img" :alt="'顾问二维码 ' + (idx+1)" class="qr-img" />
              <div v-else class="qr-placeholder"><i class="fab fa-weixin"></i><span>二维码占位</span></div>
            </div>
            <div class="qr-card-label">扫码添加「AI智能体」专属顾问</div>
            <div class="qr-scan-hint"><i class="fas fa-qrcode"></i> 扫一扫即可添加</div>
          </div>
        </div>
        <p class="qr-footer-tip">或致电 <strong>185-1017-6330</strong> 直接预约顶层顾问服务</p>
      </div>
    </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'ProductDetail_AiAgent',
  data() {
    return {
      showModal: false,
      showQrModal: false,
      qrImages: [require('@/assets/img/qr_gu.jpg'), require('@/assets/img/qr_sang.jpg')],
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    submitForm() {
      alert('表单已提交');
      this.showModal = false;
    },
    showQrCode() {
      this.showQrModal = true;
    },
    downloadBrochure() {
      alert('产品手册下载中…… (实际可替换为PDF链接)');
    }
  }
};
</script>

<style scoped>
.aia-page {
  --aia-primary-dark: #1D4E4E;
  --aia-primary-soft: #e9f3f2;
  --aia-accent-gold: #D4AF37;
  --aia-accent-blue: #2A7DE1;
  --aia-gray-light: #f8fafc;
  --aia-gray-border: #e2e8f0;
  --aia-text-dark: #0f2a2a;
  --aia-text-regular: #2d3f4b;
  --aia-white: #ffffff;
  --aia-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);

  background-color: #ffffff;
  color: var(--aia-text-regular);
  line-height: 1.5;
  font-family: 'Inter', 'PingFang SC', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

.aia-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2px;
}

section.aia-container {
  padding: 40px 12px;
}

.aia-h1, .aia-h2, .aia-h3 {
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--aia-text-dark);
}

.aia-h1 {
  font-size: 42px;
  line-height: 1.2;
}

.aia-h2 {
  font-size: 2.2rem;
  margin-bottom: 24px;
}

.aia-h2 i {
  color: var(--aia-accent-blue);
  margin-right: 8px;
}

.aia-h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.aia-subhead {
  font-size: 1.2rem;
  color: #4f6f7f;
  max-width: 800px;
  margin-bottom: 40px;
}

.aia-btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 40px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1rem;
  border: 1px solid transparent;
  cursor: pointer;
}

.aia-btn-primary {
  background-color: var(--aia-primary-dark);
  color: white;
  box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
}

.aia-btn-primary:hover {
  background-color: #0e3a3a;
  transform: translateY(-2px);
}

.aia-btn-outline {
  background-color: transparent;
  border: 1.5px solid var(--aia-primary-dark);
  color: var(--aia-primary-dark);
}

.aia-btn-outline:hover {
  background-color: var(--aia-primary-dark);
  color: white;
}

.aia-btn-accent {
  background-color: var(--aia-accent-blue);
  color: white;
  box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
}

.aia-btn-accent:hover {
  background-color: #1b64c5;
  transform: translateY(-2px);
}

/* 关键词标签云 */
.aia-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.aia-keyword-tag {
  background: var(--aia-primary-soft);
  color: var(--aia-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.aia-keyword-tag.highlight {
  background: var(--aia-accent-gold);
  color: #1e3c3c;
}

/* 卡片网格 */
.aia-card-grid-3, .aia-card-grid-4, .aia-card-grid-6 {
  display: grid;
  gap: 24px;
  margin: 40px 0;
}

.aia-card-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.aia-card-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.aia-card-grid-6 {
  grid-template-columns: repeat(3, 1fr);
}

.aia-feature-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--aia-shadow);
  border: 1px solid var(--aia-gray-border);
  transition: transform 0.2s;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.aia-feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}


.aia-list-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-start;
}

.aia-list-item i {
  color: var(--aia-accent-blue);
  font-size: 1.1rem;
  margin-top: 3px;
  min-width: 20px;
}

.aia-stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.aia-stat-card {
  background: var(--aia-primary-soft);
  border-radius: 32px;
  padding: 32px 24px;
  text-align: center;
}

.aia-stat-number {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--aia-primary-dark);
  margin-bottom: 8px;
}

.aia-client-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.aia-client-tag {
  background: white;
  border: 1px solid var(--aia-gray-border);
  padding: 8px 22px;
  border-radius: 40px;
  font-weight: 500;
  color: var(--aia-text-dark);
}

/* 技术架构卡片 */
.aia-arch-card {
  background: var(--aia-primary-soft);
  border-radius: 32px;
  padding: 36px;
  margin-top: 30px;
}

.aia-arch-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.aia-arch-item {
  background: white;
  border-radius: 24px;
  padding: 24px;
}

/* 合规认证 */
.aia-compliance-badge {
  display: inline-block;
  background: var(--aia-accent-gold);
  color: #1e3c3c;
  padding: 8px 18px;
  border-radius: 40px;
  font-weight: 600;
  margin-right: 12px;
  margin-bottom: 12px;
}

/* FAQ */
.aia-faq-list {
  max-width: 900px;
  margin: 40px auto 0;
}

.aia-faq-item {
  padding: 22px 0;
  border-bottom: 1px solid var(--aia-gray-border);
}

.aia-faq-question {
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  gap: 16px;
  color: var(--aia-text-dark);
}

.aia-faq-question i {
  color: var(--aia-accent-gold);
}

.aia-faq-answer {
  margin-top: 12px;
  color: #3f5465;
  padding-left: 40px;
}

/* ============ 预约咨询区段 ============ */
.section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
}
.cta-section {
  margin-bottom: 60px;
}
.cta-inner {
  background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
  border: 1px solid #D6E2F5;
  border-radius: 24px;
  padding: 48px 40px;
  text-align: center;
  color: #0E1F52;
  box-shadow: 0 8px 32px rgba(14,31,82,0.08);
}
.cta-heading {
  font-size: 24px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 10px;
  line-height: 1.45;
}
.cta-sub {
  font-size: 14px;
  color: #5A5E66;
  margin-bottom: 32px;
}
.cta-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s;
  text-decoration: none;
}
.cta-btn--primary {
  background: #1F3F8F;
  color: #fff;
}
.cta-btn--primary:hover {
  background: #0E1F52;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(14,31,82,0.22);
}
.cta-btn--outline {
  background: #fff;
  color: #1F3F8F;
  border: 2px solid #1F3F8F;
}
.cta-btn--outline:hover {
  background: #EAF0FB;
  border-color: #0E1F52;
  color: #0E1F52;
  transform: translateY(-2px);
}
.cta-contact-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #7B8794;
  font-size: 12px;
}
.cta-contact-row i { margin-right: 4px; color: #1F3F8F; }
.cta-contact-row .divider { color: #CBD3E0; }

/* ============ 弹窗通用 ============ */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.65);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.modal-container {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(14,31,82,0.22);
  overflow: hidden;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid #EEF1F8;
  position: relative;
}
.modal-header-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #EAF0FB;
  color: #1F3F8F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.qr-header-icon {
  background: #e8f5e9;
  color: #07c160;
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #0E1F52;
  margin: 0 0 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: #7b8794;
  margin: 0;
}
.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #F4F6FB;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5f6a7d;
  font-size: 14px;
  transition: background 0.2s;
}
.modal-close-btn:hover { background: #e2e8f4; }

/* 预约表单 */
.appt-form {
  padding: 16px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 480px) {
  .form-row { grid-template-columns: 1fr; }
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #2B2F3A;
}
.form-group .required { color: #e55353; }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1.5px solid #E0E6F0;
  border-radius: 8px;
  font-size: 13px;
  color: #2B2F3A;
  background: #FAFBFD;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  resize: vertical;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #1F3F8F;
  box-shadow: 0 0 0 3px rgba(31,63,143,0.1);
  background: #fff;
}
.form-submit-btn {
  width: 100%;
  padding: 11px;
  background: #1F3F8F;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s, transform 0.2s;
  margin-top: 4px;
}
.form-submit-btn:hover {
  background: #0e3170;
  transform: translateY(-1px);
}
.form-privacy {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  margin: -4px 0 0;
}
.form-privacy i { margin-right: 4px; }

/* 二维码弹窗 */
.qr-modal { max-width: 560px; }
.qr-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 24px 28px;
}
.qr-card {
  flex: 1;
  min-width: 180px;
  max-width: 220px;
  background: #F8FAFF;
  border-radius: 16px;
  border: 1px solid #E0E8F8;
  padding: 20px 16px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.qr-img-wrap {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dde5f5;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}
.qr-placeholder i { font-size: 36px; color: #07c160; opacity: 0.5; }
.qr-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #0E1F52;
  line-height: 1.4;
}
.qr-scan-hint {
  font-size: 12px;
  color: #9ca3af;
}
.qr-scan-hint i { margin-right: 4px; }
.qr-footer-tip {
  text-align: center;
  font-size: 13px;
  color: #7b8794;
  padding: 0 28px 22px;
  margin: 0;
}
.qr-footer-tip strong { color: #0E1F52; }

/* 弹窗入场动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(24px) scale(0.97);
  opacity: 0;
}

.aia-footer {
  text-align: center;
  padding: 40px 0;
  color: #7f8d9c;
  border-top: 1px solid var(--aia-gray-border);
  margin-top: 40px;
}

.aia-page h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

/* 面包屑导航 */
.gov-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}

.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-nav .current {
  color: var(--gov-accent-blue);
  font-weight: 600;
}

/* 底部转化 */
.cta-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin: 30px 0;
  flex-wrap: wrap;
}

.qr-code {
  display: inline-block;
  background: white;
  padding: 12px 24px;
  border-radius: 60px;
  margin-top: 20px;
  cursor: pointer;
  color: var(--deep-indigo);
}

.btn-primary {
  display: inline-block;
  background: #1F3F8F;
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
  text-decoration: none;
  font-size: 16px;
}
.btn-primary:hover {
  background: #0e3170;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(31,63,143,0.3);
}

.btn-outline-light {
  background: #EAF0FB;
  color: black;
  border: 1px solid #0e3170;
  padding: 14px 36px;
  border-radius: 60px;
  font-weight: 600;
  transition: 0.3s;
  text-decoration: none;
}
.btn-outline-light:hover {
  background: rgba(255,255,255,0.1);
  border-color: #0e3170;
}

/* 响应式 */
@media (max-width: 1100px) {
  .aia-card-grid-6 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 900px) {
  .aia-card-grid-3, .aia-card-grid-4, .aia-card-grid-6, .aia-stat-grid, .aia-arch-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .aia-card-grid-3, .aia-card-grid-4, .aia-card-grid-6, .aia-stat-grid, .aia-arch-grid {
    grid-template-columns: 1fr;
  }
  .aia-h1 {
    font-size: 2.5rem;
  }
}
</style>
